<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-https"/> {{caption}}
        <div class="card-header-actions">
          <CButton :color="filters ? 'dark' : 'warning'" size="sm" @click="toggleFilters" style="height: 26px; padding: 2px 5px;"><CIcon name="cil-filter"/></CButton>
          <CButton color="success" size="sm" @click="importModal()" v-if="type == 'general'" v-show="permissions && permissions['challenges.write'] === true">Importar Ventas</CButton>
        </div>
      </slot>
    </CCardHeader>
    <CCardBody>
      <CRow v-if="filters">
        <CCol md="6">
          <div role="group" class="form-group" style="margin: -10px 0px 10px" v-if="type == 'general'">
            <label> Vendedor:</label>
            <CSelect
              :value.sync="supplierSelect" 
              :options="suppliersOptions"
              @change="changeFilters"
            />                        
          </div>
        </CCol>        
        <CCol md="6">
          <div role="group" class="form-group" style="margin: -10px 0px 10px">
            <label> Rango de Fechas:</label>
            <v-date-picker                    
              v-model="range"    
              class="date-picker"
              locale="es-MX" size="sm"          
              mode="range"
            />        
          </div>
        </CCol>
    </CRow>
      <CDataTable
        :hover="hover"
        :striped="striped"
        :border="border"
        :small="small"
        :fixed="fixed"
        :items="sales"
        :fields="fields"
        :items-per-page="50"
        :dark="dark"
        pagination
      >
        <template #date="{item}"><td class="text-center w75" style="font-size: 12px; padding: 0 !important;">{{item.date | date}}</td></template>
        <template #product="{item}"><td class="text-left w250" style="font-size: 12px; padding: 0 0 0 5px !important;">{{item.product_code}} - {{item.product_name}}</td></template>
        <template #sname="{item}"><td class="text-left w250" style="font-size: 12px; padding: 0 0 0 5px !important;">{{item.supplier_code}} - {{item.supplier_name}}<br />{{item.customer_code}} - {{item.customer_name}}</td></template>
        <template #boxes="{item}"><td class="text-right w100" style="font-size: 12px; padding: 0 5px 0 0 !important;">{{item.boxes}}</td></template>
        <template #total="{item}"><td class="text-right w100" style="font-size: 12px; padding: 0 5px 0 5px !important;"><span style="float: left;">$</span> {{item.total | currency}}</td></template>
        <template #actions="{item}">
          <td class="table_actions w50" style="font-size: 12px; padding: 0 !important;">
            <span v-if="!permissions || permissions['challenges.write'] !== true">-</span>
            <CButton color="danger" size="sm" @click="deleteModal(item)" v-if="permissions && permissions['challenges.write'] === true"><CIcon name="cil-trash"/></CButton>
          </td>
        </template>
      </CDataTable>
    </CCardBody>
    <ImportSalesModal ref="importModal" @import="importProcess"></ImportSalesModal>
    <DeleteModal ref="deleteModal" @delete="deleteProcess"></DeleteModal>
  </CCard>
</template>

<script>
import { DatePicker } from 'v-calendar'
import moment from 'moment';
import moment_timezone from 'moment-timezone';

import ImportSalesModal from '../sales/ImportSalesModal.vue'
import DeleteModal from '../global/DeleteModal.vue'
import customers_ws from '../../services/customers';
import suppliers_ws from '../../services/suppliers';
import cedis_ws from '../../services/cedis';
import ws_sales from '../../services/sales';
import ws from '../../services/challenges';
import store from '../../store'

export default {
  name: 'ChallengeSales',
  components: { ImportSalesModal, DeleteModal, 'v-date-picker': DatePicker },
  props: {
    items: Array,
    permissions: Object,
    fields: {
      default () {
        return [
          {key: 'date', label: 'Fecha'},
          {key: 'product', label: 'Producto'},
          {key: 'sname', label: 'Vendedor - Cliente'},
          {key: 'boxes', label: 'Cajas'},
          {key: 'total', label: 'Monto'},
          {key: 'actions', label: 'Acciones', class: 'actions' },
        ]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    type: {
      type: String,
      default: 'general'
    },
    reference: 0,
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  data() {
    return {
      filters: false,
      challenge: {
        'type': 'boxes'
      },
      sales: [],
      customers: [],
      customerSelect: "",
      customersOptions: [],
      suppliers: [],
      supplierSelect: "",
      suppliersOptions: [],
      cedis: [],
      cedisSelect: "",
      cedisOptions: [],
      range: {
        start: new moment().startOf('year').toDate(),
        end: new moment().endOf("year").toDate(),
      },
      toasts: [],
      tableFilter: {
        label: 'Buscar: ',
        placeholder: '...'
      }
    }
  },
  mounted: async function() {

  },
  methods: {
    async loadChallenge (challenge) {
      this.challenge = challenge;

      this.loading();

      let response = await ws.getSales(this.challenge.id); 

      if(response.type == "success"){
        this.sales = response.data;
      }

      let response2 = await suppliers_ws.getByChallenge(this.challenge.id); 

      if(response2.type == "success"){
        this.suppliers = response2.data;
        this.suppliersOptions = await this.$parseSelectOptionsOrdered(this.suppliers, "id", "code:name",[{"label": "Todos los Vendedores","value":""}]);
      }

      this.loaded();
    },
    toggleFilters () {
      this.filters = !this.filters;
    },
    async changeFilters () {
      this.loading();

      let filters = this.getFilters();
      let response = await ws.getSalesFiltered(this.challenge.id, filters);

      if(response.type == "success"){
        this.sales = response.data;
      }

      this.loaded();
    },
    getFilters(){
      let filters = {
        date : [moment(this.range.start).format("YYYY-MM-DD"),moment(this.range.end).format("YYYY-MM-DD")],
        supplier_id : this.supplierSelect,
        challenge_id: this.challenge_id
      };

      if(this.type == "supplier"){
        filters.supplier_id = this.reference;
      }

      return filters;
    },
    importModal () {
      this.$refs.importModal.importModal(this.challenge.id);
    },
    deleteModal (item) {
      this.$refs.deleteModal.show("Eliminar Venta", item.id, item.name);
    },
    async importProcess(data) {
      this.sales = data;
      this.$emit("refresh", data );
    },
    
    async deleteProcess(id) {
      let response = await ws.deleteSale({id: id});
      
      if(response.type == "success"){
        this.sales = response.data;
      }

      this.showToast(response.type, response.message);
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  },
  watch: {
    range: async function(){
      await this.changeFilters();
    }
  },
}
</script>
